export default {

  setSimpleCustomerAttribute ({ commit }, {
    key,
    value
  }) {
    commit('setSimpleCustomerAttribute', {
      key,
      value
    })
  },

  async getPublicCustomer ({ commit }) {
    const { data } = await this.$axios.get('/public/customer/get', { withCredentials: true })
    commit('setCustomer', data.customer)
    commit('setCustomerAddress', data.customerAddress)
    commit('setMerchant', data.merchant)
    commit('setMerchantAddress', data.merchantAddress)
  },

  getOwner ({ commit }, productId) {
    return this.$axios.get('/public/customer/get-owner/' + productId, { withCredentials: true }).then((response) => {
      commit('setCustomerWithWrapper', response.data)
    })
  },

  getOwnerSegmentation ({ commit }, { entityId }) {
    return this.$axios.get('/public/customer/get-owner-segmentation/' + entityId, { withCredentials: true }).then((response) => {
      commit('setCustomerSegmentation', response.data)
    })
  },

  getCustomer ({ commit }) {
    return this.$axios.get('/private/customer/get', { withCredentials: true })
      .then((response) => {
        commit('setCustomerWithWrapper', response.data)
      })
  },

  getMerchantCookie ({ commit }, secret) {
    return this.$axios.get('/public/customer/merchant/cookie/get?mc=' + secret, { withCredentials: true })
  },

  async getCustomersSearches ({
    commit,
    state
  }) {
    const orderBy = state.savedSearchesOrderBy
    const orderDir = state.savedSearchesOrderDir
    const page = state.savedSearchesPage
    const { data } = await this.$axios.get(`/private/customer/searches/get?page=${page}&orderBy=${orderBy}&orderDir=${orderDir}`)
    commit('setSavedSearches', data)
  },
  async hasCustomersAnySearches ({ commit }, active = null) {
    if (this.$auth.loggedIn) {
      const { data } = await this.$axios.get('/private/customer/searches/has-any', {
        params: { active }
      })
      if (active === true) {
        commit('setHasCustomerAnyActiveSearches', data)
      } else {
        commit('setHasCustomerAnySearches', data)
      }
    }
  },

  async getCustomerAttributes ({ commit }) {
    const storeCode = this.app.i18n.locale

    const { data } = await this.$axios.get(`/public/attributes/all/customer/${storeCode}`)
    commit('setCustomerAttributes', data)
  },

  async getCustomerAddressAttributes ({ commit }) {
    const storeCode = this.app.i18n.locale

    const { data } = await this.$axios.get(`/public/attributes/all/customer_address/${storeCode}`)
    commit('setCustomerAddressAttributes', data)
  },

  async getMerchantAttributes ({ commit }) {
    const storeCode = this.app.i18n.locale

    const { data } = await this.$axios.get(`/public/attributes/all/merchant/${storeCode}`)
    commit('setMerchantAttributes', data)
  },

  async getMerchantAddressAttributes ({ commit }) {
    const storeCode = this.app.i18n.locale

    const { data } = await this.$axios.get(`/public/attributes/all/merchant_address/${storeCode}`)
    commit('setMerchantAddressAttributes', data)
  },

  async getAds ({ commit }, page) {
    const { data } = await this.$axios.get('/private/customer/products/get',
      {
        params: {
          page,
          storeCode: this.$i18n.locale
        }
      }
    )
    commit('setAds', data)
  },

  async getAdsInEditing ({ commit }) {
    if (this.$auth.loggedIn) {
      const { data } = await this.$axios.get('/private/customer/products/get?page=1&itemsPerPage=10&status=editing')
      commit('setAdsInEditing', data)
    } else {
      const { data } = await this.$axios.get('/public/customer/ads-in-editing-for-uuid', { withCredentials: true })
      commit('setAdsInEditing', data)
    }
  },

  async getAdsInUnderReview ({ commit }) {
    const { data } = await this.$axios.get('/private/customer/products/get?page=1&itemsPerPage=10&status=under_review')
    commit('setAdsInUnderReview', data)
  },

  async getWatchlist ({ commit }, query) {
    // console.log('getWatchlist', query)
    const storeCode = this.app.i18n.locale

    const response = await this.$axios.get('/private/customer/watchlist/get', {
      params: {
        ...query,
        storeCode
      }
    })

    commit('setWatchlist', response.data)
  },

  async getPurchases ({ commit }, query) {
    const storeCode = this.app.i18n.locale
    const response = await this.$axios.get('/private/customer/my-purchases/get', {
      params: {
        ...query,
        storeCode
      }
    })
    commit('setPurchases', response.data)
  },

  getEmailAutomationSettings ({ commit }, {
    email,
    hash
  }) {
    if (email && hash) {
      return this.$axios.get(`/public/email-automation/all/get?e=${encodeURIComponent(email)}&h=${hash}`).then((response) => {
        commit('setEmailAutomations', response.data)
      })
    } else {
      return this.$axios.get('/public/email-automation/all/get').then((response) => {
        commit('setEmailAutomations', response.data)
      })
    }
  },

  async deleteMerchantAttributeByCode ({
    commit,
    state
  }, attributeCode) {
    const url = `/private/merchant/delete-by-attribute-code/${attributeCode}`

    await this.$axios.delete(url, { withCredentials: true })
  }

}
